import {
  Menu,
  MenuButton,
  MenuList,
  Avatar,
  Flex,
  Text,
  Box,
  Image,
  Button,
  Grid,
  GridItem,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import {
  useGetSignStatusQuery,
  usePostSignMutation,
  useLogoutMutation,
} from "@/services/api/endpoints/users";
import { ServerError } from "@/types/errors";

import { BiSolidEdit } from "react-icons/bi";
import viplevel from "@/assets/viplevel.png";
import medal from "@/assets/medal.png";
import invitedBg from "@/assets/images/btn_invited_bg.png";
import jifenBg from "@/assets/images/personmeu_bg.png";
import RightArrow from "@/assets/images/rightarr.png";
import ucIcon1 from "@/assets/images/usermenu_icon1.png";
import HucIcon1 from "@/assets/images/usermenu_icon12.png";
import ucIcon2 from "@/assets/images/usermenu_icon2.png";
import HucIcon2 from "@/assets/images/usermenu_icon22.png";
import ucIcon3 from "@/assets/images/usermenu_icon3.png";
import HucIcon3 from "@/assets/images/usermenu_icon32.png";
import ucIcon4 from "@/assets/images/usermenu_icon4.png";
import HucIcon4 from "@/assets/images/usermenu_icon42.png";
import ucIcon5 from "@/assets/images/usermenu_icon5.png";
import HucIcon5 from "@/assets/images/usermenu_icon52.png";
import ucIcon6 from "@/assets/images/usermenu_icon6.png";
import HucIcon6 from "@/assets/images/usermenu_icon62.png";
import ucIcon7 from "@/assets/images/usermenu_icon7.png";
import HucIcon7 from "@/assets/images/usermenu_icon72.png";
import ucIcon8 from "@/assets/images/usermenu_icon8.png";
import HucIcon8 from "@/assets/images/usermenu_icon82.png";

import ucSet from "@/assets/images/uc_icon_set.png";
import ucExit from "@/assets/images/uc_icon_exit.png";
import { useEffect, useState } from "react";
import PayCenterModal from "@/components/payCenterModal";
import { useSelector, useDispatch } from "react-redux";
import { clearUser, selectAvatar, selectUser, updateUser } from "@/reducer/userslice";
import { clearAllCookies } from "@/utils/utils";
import Client4 from "@/services/api/client4";

type Props = {
  menuOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
};

const PersonalMenu = (props: Props) => {
  const { menuOpen, openMenu, closeMenu } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const avatar = useSelector(selectAvatar);
  const toast = useToast();
  const PayControl = useDisclosure();
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [username, setUsername] = useState<string>("你的名字");
  const [isUsernameEdit, setIsUsernameEdit] = useState(false);
  const [isSign, setIsSign] = useState<boolean>(false);
  const userId = user.id;
  const [postSign, { isSuccess: postSignSuccess }] = usePostSignMutation();
  const { data: signStatus, isSuccess: getSignStatusSuccess } =
    useGetSignStatusQuery({ userId });
  const [logout] = useLogoutMutation();

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
  };
  const handleEditUsername = () => {
    // setIsUsernameEdit(true);
    navigate("/profile"); // 切换到修改个人资料页
  };
  const handleUsernameBlur = () => {
    setIsUsernameEdit(false);
  };

  const handleShareInvitation = () => {
    navigate("/shareinvitation"); // 切换到首页
  };

  const handleGoIntegral = () => {
    navigate("/integral"); // 切换到我的积分
  };

  // 购买积分
  const handlePurchaseIntegral = () => {
    PayControl.onOpen();
    setTabIndex(1);
  };
  //   充值会员
  const handleRechargeMembership = () => {
    PayControl.onOpen();
    setTabIndex(0);
  };

  // 签到
  const handleSignIn = async () => {
    const res = await postSign({ userId });
    console.log(res, "123");
    if (res) {
      setIsSign(true);
      updateUserInfo();
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (getSignStatusSuccess && isMounted) {
      if (signStatus.hadsign) {
        setIsSign(false);
      } else {
        setIsSign(true);
      }
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const handleLoginOut = async () => {
    const result = await logout()
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });

    if (result) {
      closeMenu();
      window.localStorage.removeItem("token");
      window.sessionStorage.clear();
      clearAllCookies();
      dispatch(clearUser());
    }
  };
  const updateUserInfo = async() => {
    const userInfo = await Client4.getMe();
    dispatch(updateUser(userInfo));
  };
  useEffect(() => {
    if (menuOpen) {
      updateUserInfo();
    }
  }, [menuOpen]);

  return (
    <>
      <Menu isOpen={menuOpen} onClose={closeMenu}>
        <MenuButton
          as={Avatar}
          w="36px"
          h="36px"
          src={avatar}
          cursor={"pointer"}
          onClick={openMenu}
        />
        <MenuList
          w={"384px"}
          color="#333333"
          maxH="calc(100vh - 80px)"
          overflow={"auto"}
        >
          <Box m={"20px 30px"}>
            <Flex position={"relative"} alignItems={"center"}>
              <Avatar src={avatar} w={"56px"} h={"56px"} />
              <Box ml="20px" mr="20px" flex={1}>
                <Flex alignItems="center" gap="20px">
                  <Text
                    display={isUsernameEdit ? "none" : "block"}
                    fontSize={"18px"}
                    fontWeight="bold"
                  >
                    {user.username || user.nickname}
                  </Text>
                  {/* <Input
                    display={isUsernameEdit ? "block" : "none"}
                    size="sm"
                    variant={"outline"}
                    borderRadius="4PX"
                    value={username}
                    onChange={handleUsernameChange}
                    onBlur={handleUsernameBlur}
                  /> */}
                  <Box display={isUsernameEdit ? "none" : "block"}>
                    <BiSolidEdit
                      fontSize={"18px"}
                      color="#B9B9B9"
                      cursor={"pointer"}
                      onClick={handleEditUsername}
                    />
                  </Box>
                </Flex>
                <Flex alignItems="center">
                  <Image
                    mr="20px"
                    src={viplevel}
                    cursor="pointer"
                    onClick={() => navigate("/grades")}
                  />
                  <Image
                    mr="10px"
                    src={medal}
                    cursor="pointer"
                    onClick={() => navigate("/grades")}
                  />
                  <Text
                    fontSize={"14px"}
                    color="#B9B9B9"
                    cursor="pointer"
                    onClick={() => navigate("/grades")}
                  >
                    {user.medals || 0}
                  </Text>
                </Flex>
              </Box>
              <Box
                width={"66px"}
                height="56px"
                position={"relative"}
                cursor="pointer"
                onClick={handleShareInvitation}
                _hover={{
                  boxShadow: "2px 2px 10px 0px rgba(73, 106, 225, 0.1)",
                }}
              >
                <Image src={invitedBg} />
              </Box>
            </Flex>
            <Flex justifyContent={"space-between"} mt={"20px"} color="#B9B9B9">
              <Flex
                alignItems={"center"}
                cursor="pointer"
                onClick={() => navigate("/followandfans")}
              >
                <Text color="#B9B9B9" fontSize="10px">
                  关注：
                </Text>
                <Text color={"#333333"} fontSize="14px" as={"b"}>
                  {user.followers || 0}
                </Text>
              </Flex>
              <Flex
                alignItems={"center"}
                cursor="pointer"
                onClick={() => navigate("/followandfans")}
              >
                <Text color="#B9B9B9" fontSize="10px">
                  粉丝：
                </Text>
                <Text color={"#333333"} fontSize="14px" as={"b"}>
                  {user.fans || 0}
                </Text>
              </Flex>
              <Flex alignItems={"center"}>
                <Text color="#B9B9B9" fontSize="10px">
                  获赞：
                </Text>
                <Text color={"#333333"} fontSize="14px" as={"b"}>
                  {user.likes || 0}
                </Text>
              </Flex>
            </Flex>
          </Box>
          <Box
            ml={"30px"}
            mr={"30px"}
            borderRadius={"2px"}
            bgColor="#E8ECF6"
            h={"120px"}
            p="10px"
            boxSizing="border-box"
            style={{
              backgroundImage: `url('${jifenBg}')`,
              backgroundPosition: "top left 56px",
              backgroundRepeat: "no-repeat",
            }}
          >
            <Flex mb="14px" fontSize={"12px"} justifyContent={"space-between"}>
              <Box color="#333333" fontSize={"12px"} fontWeight="normal">
                我的积分
              </Box>
              <Button
                color="#8E94A9"
                fontSize={"12px"}
                fontWeight="normal"
                variant="link"
                onClick={handleGoIntegral}
              >
                查看详情 <Image src={RightArrow} />
              </Button>
            </Flex>
            <Text
              color="#333333"
              as={"b"}
              fontSize={"24px"}
              fontFamily="Allerta"
            >
              {user.totalcoin || 0}
            </Text>
            <Flex justifyContent={"flex-end"}>
              <Button
                borderRadius={"40px"}
                width={"80px"}
                height={"33px"}
                color="#27314D"
                bgColor="none"
                border={"1px solid #27314D"}
                fontSize="12px"
                // colorScheme="#27314D"
                _hover={{
                  color: "#27314D",
                  bgColor: "#CBD1DF",
                  border: "1px solid #8E94A9",
                }}
                onClick={handleRechargeMembership}
              >
                充值会员
              </Button>
              <Button
                borderRadius={"40px"}
                ml={"10px"}
                color="#DCE0EB"
                width={"80px"}
                height={"33px"}
                fontSize="12px"
                background={"linear-gradient(90deg, #8E94A9 0%, #27314D 100%)"}
                _hover={{
                  background:
                    "linear-gradient(90deg, #27314D 0%, #8E94A9 100%)",
                }}
                onClick={handlePurchaseIntegral}
              >
                购买积分
              </Button>
            </Flex>
          </Box>
          <Box ml={"30px"} mr={"30px"} mt={"30px"}>
            <Button
              w={"100%"}
              h="44px"
              borderRadius={"2px"}
              fontSize="14px"
              color={"#27314D"}
              background={"linear-gradient(90deg, #F1EFEA 1%, #F0E4D3 100%)"}
              _hover={{
                background: "linear-gradient(90deg, #F7F4EF 1%, #F6EBDC 100%)",
              }}
              isDisabled={isSign}
              onClick={handleSignIn}
            >
              {isSign ? "已签到" : "立即签到"}
            </Button>
          </Box>
          <Box ml={"30px"} mr={"30px"} mt={"30px"}>
            <Grid
              templateColumns="repeat(4, 1fr)"
              templateRows="repeat(2, 1fr)"
              gap={1}
            >
              <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon1}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon1}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                  onClick={() => navigate("/myhomepage/" + userId)}
                >
                  我的主页
                </Box>
              </GridItem>
              <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon2}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon2}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                  onClick={() => {
                    navigate("/creatorcenter/mymodels");
                  }}
                >
                  创作者中心
                </Box>
              </GridItem>
              <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon3}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon3}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                  onClick={() => {
                    navigate("/myactivities");
                  }}
                >
                  我的活动
                </Box>
              </GridItem>
              <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon4}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon4}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                  onClick={() => {
                    navigate("/task");
                  }}
                >
                  我的任务
                </Box>
              </GridItem>

              <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon5}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon5}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                  onClick={() => navigate("/collectandlike")}
                >
                  收藏与点赞
                </Box>
              </GridItem>
              {/* <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon6}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon6}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                  onClick={() => {navigate("/team")}}
                >
                  我的团队
                </Box>
              </GridItem> */}
              {/* <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon7}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon7}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                  onClick={() => {navigate("/course")}}
                >
                  我的课程
                </Box>
              </GridItem> */}
              <GridItem>
                <Box
                  w="76px"
                  h="76px"
                  mb="14px"
                  fontSize={"12px"}
                  color="#8E94A9"
                  pt="48px"
                  textAlign={"center"}
                  bg={`url('${ucIcon8}')`}
                  backgroundSize="24px 24px"
                  backgroundPosition="top 14px center"
                  bgRepeat={"no-repeat"}
                  cursor="pointer"
                  _hover={{
                    bg: `url('${HucIcon8}')`,
                    bgRepeat: "no-repeat",
                    backgroundSize: "24px 24px",
                    backgroundPosition: "top 14px center",
                  }}
                >
                  帮助中心
                </Box>
              </GridItem>
            </Grid>
          </Box>
          <Flex justifyContent={"flex-end"} mr={"30px"}>
            <Button
              w="64px"
              fontSize={"12px"}
              color={"#8E94A9"}
              fontWeight="normal"
              colorScheme="whiteAlpha"
              onClick={() => navigate("/securityset")}
            >
              <Image mr="2px" src={ucSet} /> 安全设置
            </Button>
            <Button
              w="64px"
              fontSize={"12px"}
              fontWeight="normal"
              color={"#8E94A9"}
              colorScheme="whiteAlpha"
              ml={"20px"}
              onClick={handleLoginOut}
            >
              <Image mr="2px" src={ucExit} /> 退出登录
            </Button>
          </Flex>
        </MenuList>
      </Menu>
      <PayCenterModal
        tabIndex={tabIndex}
        isOpen={PayControl.isOpen}
        onClose={PayControl.onClose}
      />
    </>
  );
};

export default PersonalMenu;
